var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tr',[_c('td',[_vm._v("\n      "+_vm._s(_vm.item.descricaoOrigem)+"\n  ")]),_c('td',[_vm._v("\n      "+_vm._s(_vm.item.entidadeOrigem)+"\n  ")]),_c('td',[_vm._v("\n      "+_vm._s(_vm.item.problema)+"\n  ")]),_c('td',[_vm._v("\n      "+_vm._s(_vm.$date.format(_vm.item.dataCadastro))+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }